module.exports = __webpack_public_path__ + "img/phone.440c11ee.svg";